import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
// import HomeDE from './de/de';
import HomeES from './es/es';
import HomeEN from './en/en';
import HomeDE from './de/de';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/es" />} />
                <Route path="/es" element={<HomeES></HomeES>}/>
                <Route path="/en" element={<HomeEN></HomeEN>}/>
                {/* <Route path="/en" element={<HomeEN></HomeEN>} /> */}
                <Route path="/de" element={<HomeDE></HomeDE>} />
        </Routes>
      </Router>
        
    </div>
  );
}

export default App;
